import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
const styles = StyleSheet.create({
   
    titleContainer:{
        flexDirection: 'row',
    },
    reportTitle:{
        color: '#244776',
        fontSize: 20,
    }
  });


  const Title = ({title}) => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>{title}</Text>
    </View>
  );
  
  export default Title